import { useAudienceCatalog } from '@/hooks/useAudienceCatalog';
import { useTranslation } from '@/hooks/useTranslation';
import { CampaignAudience } from '@/services/audienceService';
import AudienceGroupPicker from './AudienceGroupPicker';
export default function CampaignAudienceFields({ value, onChange }: {
  value: CampaignAudience; onChange: (value: CampaignAudience) => void;
}) {
  const { t } = useTranslation(), copy = t.audience;
  const query = useAudienceCatalog();
  if (query.isPending) return <p>{copy.loading}</p>;
  if (!query.data) return <p role="alert">{copy.loadError}</p>;
  const nodes = query.data.nodes;
  return <section className="space-y-4">
    <div className="grid gap-4 sm:grid-cols-2">
      <div className="space-y-2"><h3 className="font-semibold text-gray-900">{copy.includeGroups}</h3>
      <p className="text-xs text-gray-500">{copy.includeGroupsHelp}</p>
      <AudienceGroupPicker hideLabel pillTrigger nodes={nodes} label={copy.includeGroups} selected={value.includeNodeIds ?? []}
        onChange={ids => onChange({ ...value, includeNodeIds: ids })} /></div>
      <div className="space-y-2"><h3 className="font-semibold text-gray-900">{copy.excludeGroups}</h3>
      <p className="text-xs text-gray-500">{copy.excludeGroupsHelp}</p>
      <AudienceGroupPicker hideLabel pillTrigger nodes={nodes} label={copy.excludeGroups} selected={value.excludeNodeIds ?? []}
        onChange={ids => onChange({ ...value, excludeNodeIds: ids })} /></div>
    </div>
  </section>;
}
